<svelte:options accessors/>
<script>
    import {azureSearch, backendSearch, debounce} from "../utils";
    import {createEventDispatcher, onMount} from "svelte";

    let dispatch = createEventDispatcher();
    let filtered = [];
    let loading = false;
    let showResults = true;

    export let country = null;

    let term = '';
    let searchedTerm = ''

    let currentPage = 1;
    let count = 0;

    $: validTerm = term.length > 2;
    $: count = term === searchedTerm;

    const debounced = debounce(() => {
        let page = currentPage || 1;
        let sTerm = term || searchedTerm;
        azureSearch({term: sTerm, page, count, country}).then(updateData);
    }, 400);

    onMount(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('page')) {
            currentPage = +params.get('page');
        }
        if (params.get('search')) {
            term = params.get('search');
            searchedTerm = term;
            showResults = false;
            debounced();
        }
    });

    function doSearch() {
        if (validTerm) {
            showResults = true;
            loading = true;
            debounced();
            currentPage = 1;
        }
    }

    function updateData(data) {
        filtered = data.value;
        count = data.count;
        loading = false;
        if (term !== searchedTerm) {
            searchedTerm = term;
        }
    }

    export function activeSearch() {
        return term.length > 2;
    }

    export function getPage(page) {
        currentPage = page;
        localStorage.setItem('pageTrsv', page);
        term = localStorage.getItem('searchTermTrsv')
        searchedTerm = term;
        debounced();
    }

    export function showSearchResults(ev) {
        if (ev) {
            ev.preventDefault();
        }
        showResults = false;
        currentPage = 1;
        localStorage.setItem('searchTermTrsv', term);
        dispatch('search', {
            filtered, term, count: Math.ceil(count / 15), country
        });
        searchedTerm = term;
    }

    function checkValid(ev) {
        if (!ev.target.value) {
            dispatch('clear', {});
        }
    }
</script>
<form class="search-container" on:submit={showSearchResults}>
    <input type="search" bind:value={term} name="searchProduct" placeholder="Busca un producto"
           on:keyup={doSearch} on:input={checkValid} on:search={checkValid}>
    {#if validTerm && showResults}
        <div class="search" class:active="{validTerm && showResults}">
            {#if filtered.length > 0 && !loading}
                <ul class="autocom-box">
                    {#each filtered as item}
                        <li>
                            <a href="{`/productos/producto/${item.Slug}`}">
                                { item.Nombre }
                            </a>
                        </li>
                    {/each}
                </ul>
            {/if}
        </div>
        {#if filtered.length === 0 && !loading}
            <div class="search active">
                <ul class="autocom-box">
                    <li>
                        No se encontraron productos asociados con la busqueda
                    </li>
                </ul>
            </div>
        {/if}
        {#if loading}
            <div class="search active">
                <ul class="autocom-box">
                    <li>
                        Cargando...
                    </li>
                </ul>
            </div>
        {/if}
    {/if}
</form>
<style>
    .search-container {
        position: relative;
    }

    .search-results {
        position: absolute;
        top: 37px;
        left: 0;
        padding: .5rem;
        max-width: 800px;
        width: 100%;
        background-color: #fff;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
        max-height: 240px;
        overflow-y: scroll;
    }

    .search-results ul {
        list-style-type: none;
        padding: 0;
    }

    .search-results li {
        font-size: .85rem;
        padding: .25rem 1rem;
    }

    .search-results li:hover {
        background-color: #f2f3f4;
    }

    .search-results li a {
        color: #555;
    }

</style>